import React, { useMemo } from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

import { RootContainers } from '../../helpers';

type Props = {
  children: React.ReactNode;
};

function CacheConfig({ children }: Props) {
  const cache = useMemo(() => {
    const cacheOptions = {
      key: `watch-css`,
      container: RootContainers.getMUIContainer(),
    };

    return createCache(cacheOptions);
  }, []);

  return <CacheProvider value={cache}>{children}</CacheProvider>;
}

export default CacheConfig;
